'use strict';

/**
 * @function
 * @description Initializes Slick carousels
 */

function initSlick() {
    $('.slick').not('.slick-initialized').slick();
}

export default {
    init: initSlick
};

